import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Header from '../header/Header';
import BaseInfoSidebar from '../sidebar/BaseInfoSidebar';
import methods from '../../services/utility';
import StepProgress from '../../views/public/stepProgress/StepProgress';

const Layout = ({ component: Component, ...rest }) => {

  const [collapsed, setCollapsed] = useState(false);

  const isUserLogedin = methods.checkUserLogin();

  return (
    <div className='container-fluid vh-100 min-vh-100'>
      {isUserLogedin ?
        <>
          <Header setCollapsed={setCollapsed} />
          <div className='row bg-light'>
            <div className='col-lg-2 border-end border-secondary-subtle bg-white'>
              <BaseInfoSidebar />
            </div>
            <div className="col-lg-10 p-4 mx-auto">
              <StepProgress />
              <Component {...rest} />
            </div>
          </div>
        </>
        :
        <Navigate to="/login" />
      }
    </div >
  )
};

export default Layout;